import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from 'javascripts/utils/ErrorBoundary';
import randomString from 'javascripts/utils/random-id';
import Multiselect from './react/Multiselect';
import MultiselectFallback from './react/MultiselectFallback';

document
  .querySelectorAll('.multiselect:not(.multiselect--init)')
  .forEach(($multiselect) => {
    const $options = $multiselect.querySelectorAll('option');
    const options = Array.from($options || [])
      .map(($option) => ({
        text: $option.textContent.trim(),
        value: $option.value.trim(),
        selected: $option.selected,
        number: $option.getAttribute('data-number'),
      }))
      .filter((option) => option.value !== '');
    const $select = $multiselect.querySelector('.select');
    const large = $select.classList.contains('select--large');

    if (!$select) {
      console.error('Multiselect - select not found');
      return;
    }

    if (options.length === 0) {
      console.error('Multiselect - options not found');
      return;
    }

    const id = $select?.getAttribute('id') || randomString();
    const name = $select?.getAttribute('name');
    const placeholder = $select?.getAttribute('data-placeholder');
    const $label = $multiselect.querySelector('.label');
    const labelText = $label?.textContent;
    const $wrap = document.createElement('div');
    $wrap.classList.add('multiselect__wrap');
    $select.parentNode.appendChild($wrap);
    $select.style.setProperty('display', 'none');
    $label.style.setProperty('display', 'none');
    $select.setAttribute('aria-hidden', 'true');
    $label.setAttribute('aria-hidden', 'true');

    try {
      const root = createRoot($wrap);
      root.render(
        <ErrorBoundary
          fallbackComponent={() => (
            <MultiselectFallback
              id={id}
              name={name}
              options={options}
              large={large}
            />
          )}
        >
          <Multiselect
            options={options}
            id={id}
            name={name}
            placeholder={placeholder}
            labelText={labelText}
            large={large}
          />
        </ErrorBoundary>
      );
    } catch (e) {
      console.error('Multiselect - render', e);
    }
  });
